package com.neurobs.ccabserver.administrator.controller

import com.neurobs.ccab.{Group, SequenceElement, SequenceState, Test, TestRun, TestRunDetail}
import com.neurobs.js.view.Container
import com.neurobs.ccabserver.administrator.view.TestListView

class TestListController (view: TestListView) {
	private var selIndex: Option[Int] = None
	private var group = Group.empty
	private var sequence = SequenceState.empty

	def clear() = {
		selIndex = None
		group = Group.empty
		sequence = SequenceState.empty
	}

	def selectionIndex: Option[Int] = selIndex

	def selection: Option[(SequenceElement, Test)] = {
		selIndex.map { i =>
			val element = sequence.tests(i)
			(element, group.tests(element.index))
		}
	}

	def selectTest(i: Option[Int]): Unit = {
		if (i != selIndex) {
			selIndex foreach { v => view.setRowSelected(v, selected = false) }
			i foreach { v => view.setRowSelected(v, selected = true) }
			selIndex = i
			onTestSelectChange(selection)
		}
	}

	def setTests(sequence: SequenceState, group: Group, current: Option[TestRunDetail], log: List[TestRun]): Unit = {
		val reverseLog = log.reverse
		this.group = group
		this.sequence = sequence
		view.clear()
		for ((t, i) <- sequence.tests.zipWithIndex) {
			val isCurrent = current.map(_.run.seq_id == Some(t.id)).getOrElse(false)
			val pointer: TestListView.PointerType.Value =
				if (isCurrent) TestListView.PointerType.Current
				else if (sequence.next_index == i) TestListView.PointerType.Next
				else TestListView.PointerType.None
			val status: TestListView.TestStatus.Value =
				if (isCurrent) {
					val d = current.get
					if (d.status == com.neurobs.ccab.TestStatus.Running) TestListView.TestStatus.Running
					else if (d.run.error.isEmpty) TestListView.TestStatus.Success
					else TestListView.TestStatus.Failure
				}
				else {
					reverseLog.find(_.seq_id == Some(t.id)).map(r => if (r.error.isEmpty) TestListView.TestStatus.Success else TestListView.TestStatus.Failure).getOrElse(TestListView.TestStatus.Pending)
				}

			view.addRow(group.tests(t.index).name, status, pointer) { () =>
				selectTest(Some(i))
			}
		}
		selIndex.foreach { i =>
			if (i < sequence.tests.length) view.setRowSelected(i, selected = true)
			else selIndex = None
		}
	}

	var onTestSelectChange: (Option[(SequenceElement, Test)]) => Unit = (_) => Unit

	def container: Container = view.container
}
